<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">检查记录表列表</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室名称`">
          <el-select v-model="formInline.training_room" clearable filterable :placeholder="`请选择${$store.state.themeTitle}室名称`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.check_status" clearable filterable placeholder="请选择状态">
            <el-option v-for="item in $store.state.checkStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="实训项目">
          <el-input v-model="formInline.train_name" clearable placeholder="请输入实训项目"></el-input>
        </el-form-item> -->

        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新建检查记录表</el-button>
        </el-form-item>
      </el-form>
    </div>
    <custom-table :data="tableData" ref="table" border style="width: 100%">
      <custom-table-column prop="name" label="检查名称" width="160">
      </custom-table-column>
      <custom-table-column label="状态" width="100" prop="check_status"  label-class-name="checkStatus" :formatter="format_arr">
      </custom-table-column>
      <custom-table-column prop="type" label="检查类型" width="120">
      </custom-table-column>
      <custom-table-column prop="check_structure" label="检查单位" width="160">
      </custom-table-column>
      <custom-table-column prop="check_fzr" label="检查负责人" width="120">
      </custom-table-column>
      <custom-table-column prop="training_room_name" :label="`${$store.state.themeTitle}室`" width="160">
      </custom-table-column>
      <custom-table-column prop="check_form_name" label="检查表名" width="160">
      </custom-table-column>
      <custom-table-column prop="check_time" label="检查时间" width="160">
      </custom-table-column>
      <custom-table-column prop="check_desc" label="备注" min-width="200">
      </custom-table-column>
      <custom-table-column fixed="right" label="操作" width="140">
        <template slot-scope="scope">
          <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
          <!-- <el-button @click="handleAddItem(scope.row.id)" type="text" size="small">添加条目</el-button> -->
          <el-button v-if="scope.row.check_status=='0'" @click="handleApply(scope.row.id,'1')" type="text" size="small">执行</el-button>
          <el-button v-if="scope.row.check_status=='1'" @click="handleApply(scope.row.id,'2')" type="text" size="small">完成</el-button>
          <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
        </template>
      </custom-table-column>
    </custom-table>
    <div class="pageLine">
      <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" :width="type=='edit'?'1024px':'724px'">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="检查名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入检查名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="巡查活动" prop="activity_id">
          <el-select v-model="ruleForm.activity_id" style="width:216px;" placeholder="请选择巡查活动">
            <el-option v-for="item in $store.state.checkActivities" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室`" prop="training_room_id">
          <el-select v-model="ruleForm.training_room_id" style="width:216px;" :placeholder="`请选择${$store.state.themeTitle}室`" @change="handleClassChange">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检查类型" prop="type">
          <el-input v-model="ruleForm.type" placeholder="请输入检查类型" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="检查单位" prop="check_structure">
          <el-input v-model="ruleForm.check_structure" placeholder="请输入检查单位" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="检查负责人" prop="check_fzr_id">
          <el-select v-model="ruleForm.check_fzr_id" style="width:216px;" filterable :loading="loading" remote @change="handleTeacherChange" :remote-method="remoteMethod" placeholder="请选择指导教师">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id">
              <p>{{ item.name }}</p>
              <p v-if="item.number" class="el-option-tips">工号：{{ item.number }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检查表名" prop="check_form_id">
          <el-select v-model="ruleForm.check_form_id" clearable placeholder="请选择检查表" :disabled="tableData1.length>0" style="width:216px;" @change="handleCheckChange(...arguments,'change')">
            <el-option v-for="item in $store.state.checks" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检查日期" prop="check_time">
          <el-date-picker v-model="ruleForm.check_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="请选择检查日期" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="备  注" prop="check_desc">
          <el-input type="textarea" v-model="ruleForm.check_desc" style="width:532px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitFormByFun('ruleForm',createMethod)">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitFormByFun('ruleForm',updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
      <div v-if="type=='edit'" style="box-shadow: rgb(229 229 229) 0px 0px 1px 1px;padding:8px;width:100%;overflow: auto;box-sizing: border-box;">
        <div>
          <el-form :inline="true" :model="formInline1" class="demo-form-inline" label-position="left">
            <el-form-item>
              <el-button type="primary" @click="handleAddItem">添加项目</el-button>
            </el-form-item>
          </el-form>
        </div>
        <custom-table :data="tableData1" ref="table" border style="width: 100%">
          <custom-table-column prop="name" label="检查内容" width="160">
          </custom-table-column>
          <custom-table-column label="状态" width="100"  prop="rectify_status"  label-class-name="rectifyStatus" :formatter="format_arr" >
          </custom-table-column>
          <custom-table-column prop="level" label="隐患等级" width="80">
          </custom-table-column>
          <custom-table-column prop="score" label="得分" width="60">
          </custom-table-column>
          <custom-table-column prop="rectify_limit_date" label="整改期限" width="160">
          </custom-table-column>
          <custom-table-column prop="desc" label="问题描述" min-width="200">
          </custom-table-column>
          <!-- <custom-table-column label="文件" width="150">
            <template slot-scope="scope" v-if="scope.row.file">
              <el-link type="primary" v-for="(item,index) in scope.row.file.split(',')" :href="item" :key="index" target="_blank">{{ $until.getFileName(item) }}</el-link>
            </template>
          </custom-table-column> -->
        <custom-table-column label="隐患图片" min-width="240">
          <template slot-scope="scope" v-if="scope.row.file">
            <el-image v-for="(item,index) in scope.row.file.split(',')" :key="index" :src="item" :preview-src-list="scope.row.file.split(',')"  style="width: 60px; height: 60px;margin-right: 4px;">
            </el-image>
          </template>
        </custom-table-column>
          <custom-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="handleEditItem(scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="handleDeletItem(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </custom-table-column>
        </custom-table>
        <!-- <div class="pageLine">
          <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
        </div> -->
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :title="itemTitle" :visible.sync="innerDialogVisible" width="724px">
      <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
        <el-form-item label="检查内容" prop="name">
          <el-select v-model="selectVal" placeholder="请选择检查内容" style="width:532px;" @change="handleChange">
            <el-option v-for="item in checkTableItem" :key="item.id" :label="item.content" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题描述"   prop="desc">
          <el-input type="textarea" placeholder="请输入问题描述" v-model="ruleForm1.desc" style="width:532px;"></el-input>
        </el-form-item>
        <el-form-item label="分值" prop="score">
          <el-input-number v-model="ruleForm1.score" placeholder="请输入分值" :min="0" :max="maxScore" style="width:216px;"></el-input-number>
        </el-form-item>
        <el-form-item label="隐患等级" prop="level">
          <el-input v-model="ruleForm1.level" disabled placeholder="请输入检查类型" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="整改状态" prop="rectify_status">
          <el-select v-model="ruleForm1.rectify_status" placeholder="请选择整改状态" style="width:216px;">
            <el-option v-for="item in $store.state.rectifyStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="整改期限" prop="rectify_limit_date">
          <el-date-picker v-model="ruleForm1.rectify_limit_date" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="请选择整改期限" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="隐患图片" prop="file" style="width:100%">
            <Uploadd ref="uploadd" :action="action" :params="params" @setFileList="setUpFileList" @delFile="delUpFile" :btnTitle="btnTitle" :uploadType="uploadType"></Uploadd>
        </el-form-item>
        <!-- <el-form-item label="隐患级别" prop="level">
          <el-select v-model="ruleForm1.level" placeholder="请选择隐患级别" style="width:216px;">
            <el-option v-for="item in $store.state.darkLevel" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="排  序" prop="display_order">
          <el-input v-model.number="ruleForm1.display_order" placeholder="请输入排序" style="width:216px;"></el-input>
        </el-form-item> -->
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="typee=='add'" @click="submitFormByFun('ruleForm1',addCheckItem)">确认</el-button>
          <el-button type="primary" v-if="typee=='edit'" @click="submitFormByFun('ruleForm1',updateCheckItem)">编辑</el-button>
          <el-button @click="resetItemForm('ruleForm1')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinUpload } from '@/assets/js/mixin/upload';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinFormatter,mixinUpload],
  data() {
    return {
      classRooms: [],
      institutes: [
        { isid: '1', ismc: '机电学院' },
        { isid: '2', ismc: '土木学院' },
      ],
      uploadType:'image',
      props: {
        label: 'name',
      },
      btnTitle:'点击上传隐患图片',
      params: {
        type: 'safe',
      },
      itemTitle: '',
      ruleForm1: {
        name: '',
        score: '',
        desc: '',
        file: '',
        rectify_status: '',
        level: '',
        rectify_limit_date: '',
      },
      users: [],
      loading: false,
      typee: 'add',
      rules1: {
        name: [{ required: true, message: '请输入检查内容', trigger: 'blur' }],
        desc: [{ required: true, message: '请输入问题描述', trigger: 'blur' }],
        rectify_status: [{ required: true, message: '请选择整改状态', trigger: 'change' }],
        rectify_limit_date: [{ required: true, message: '请选择整改期限', trigger: 'change' }],
        score: [{ required: true, message: '请输入分值', trigger: 'blur' }],
        file: [{ required: true, message: '请上传附件' }],
      },
      itemDialogVisible: false,
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      innerDialogVisible: false,
      formInline: {
        training_room: '',
        check_status: '',
        structure_1: '',
      },
      formInline1: {},
      levell: [1],
      levell1: [1, 2, 3],
      selectName: '',
      organLabel: '',
      ruleForm: {
        name: '',
        type: '',
        activity_id:'',
        check_time: '',
        check_structure: '',
        check_fzr: '',
        check_fzr_id: '',
        check_form_name: '',
        check_form_id: '',
        check_desc: '',
        check_status: 0,
        training_room_id: '',
        training_room_name: '',
      },
      rules: {
        name: [{ required: true, message: '请输入检查名称', trigger: 'blur' }],
        type: [{ required: true, message: '请输入检查类型', trigger: 'blur' }],
        check_time: [{ required: true, message: '请选择检查时间', trigger: 'change' }],
        check_structure: [{ required: true, message: '请输入检查单位', trigger: 'blur' }],
        check_fzr_id: [{ required: true, message: '请选择检查负责人', trigger: 'change' }],
        check_form_id: [{ required: true, message: '请选择检查表名', trigger: 'change' }],
        check_status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        training_room_id: [{ required: true, message: `请选择${this.$store.state.themeTitle}室`, trigger: 'change' }],
      },
      cascaderVal: '',
      selectVal: '',
      checkItems: [],
      type: 'add',
      title: '新增',
      tableName: '实训日志',
      treeArr: [],
      tableArr: [],
      allArr: [],
      currentNode: null,
      tableData1: [],
      tableDetail: null,
      checkTableItem: [],
      maxScore: 0,
      fileFormName: 'ruleForm1', //表名
      isRequired:true
    };
  },
  created() {},
  mounted() {
    // this.getList();
    this.$store.dispatch('getTarinMent');
    this.$store.dispatch('getChecks');
    this.$store.dispatch('getCheckActivities');
    // this.$store.dispatch('getStandards');
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    handleChangeCascader(value) {
      // console.log(value);
      // console.log(this.$refs.cascader.getCheckedNodes(true));
      if (value && value.length) {
        if (value.length == 2) {
          this.ruleForm1.cate = value[1];
        }
        this.checkItems = this.$refs.cascader.getCheckedNodes(true)[0].data.list ? this.$refs.cascader.getCheckedNodes(true)[0].data.list : [];
      } else {
        this.checkItems = [];
      }
      this.selectVal = '';
      this.ruleForm1.title = '';
      this.ruleForm1.content = '';
    },
    resetItemForm(formName) {
      this.$refs[formName].resetFields();
      this.cascaderVal = '';
      this.selectVal = '';
    },
    handleApply(id, status) {
      let str = '执行';
      if (status == 2) {
        str = '完成';
      }
      this.confirmBox('warning', `此操作将${str}该检查，是否继续`, { id, check_status: status }, this.setStatus);
    },
    async setStatus(params) {
      let res = await this.$api.instance.interfaceServer(`api/safety_check/record/status/change/${params.id}`, 'post', {check_status:params.check_status});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '处理成功！',
        });
        this.getList();
      }
    },
    handleChange(value) {
      // console.log(value);
      // console.log(this.$refs.cascader.getCheckedNodes(true));
      this.maxScore = this.$until.getLabelName(this.checkTableItem, 'id', 'score', value);
      this.ruleForm1.name = this.$until.getLabelName(this.checkTableItem, 'id', 'content', value);
      this.ruleForm1.score = 0;
      this.ruleForm1.level = this.$until.getLabelName(this.checkTableItem, 'id', 'level', value);
    },
    handleDeletItem(id) {
      this.confirmBox('warning', `此操作将删除该项目，是否继续`, { id }, this.deleteItem);
    },
    async deleteItem(params) {
      let res = await this.$api.instance.interfaceServer(`api/safety_check/record/item/delete/${params.id}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.getItemList();
      }
    },
    handleClassChange(e) {
      this.ruleForm.training_room_name = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_name', e);
    },
    handleTeacherChange(val) {
      this.ruleForm.check_fzr = this.$until.getLabelName(this.users, 'id', 'name', val);
    },
    handleCheckChange(val, state) {
      this.ruleForm.check_form_name = this.$until.getLabelName(this.$store.state.checks, 'id', 'name', val);
      this.checkTableItem = this.$until.getLabelName(this.$store.state.checks, 'id', 'items', val);
      this.ruleForm1.name = '';
      this.ruleForm1.score = 0;
      if (this.type == 'edit' && state == 'change') {
        this.checkUpdateMethod();
      }
    },
    async checkUpdateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer(`api/safety_check/record/edit/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '切换检查表成功！',
        });
      }
    },
    async remoteMethod(query) {
      this.loading = true;
      this.users = [];
      let params = {
        page: 1,
        size: 10,
        name: query,
        type: '1,3,6,7',
      };
      // console.log(query)
      // return
      let res = await this.$api.query.getUsersUnLoad(params);
      if (res.code == 0 && res.data) {
        this.users = res.data.data;
        // this.total = res.data.total;
      }
      this.loading = false;

      // this.users = res.data.data;
    },
    handleAdd() {
      this.type = 'add';
      this.title = '新增';
      if (this.selectName) {
        this.selectName = '';
      }
      this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep);
      this.tableData1 = [];
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate();
        }
      });
    },
    handleAddItem() {
      this.innerDialogVisible = true;
      this.typee = 'add';
      this.itemTitle = '新增检查项目';
      this.ruleForm1 = {
        name: '',
        score: '',
        desc: '',
        file: '',
        rectify_status: '',
        level: '',
        rectify_limit_date: '',
      };
      this.selectVal = '';
      this.fileList = [];
      this.$nextTick(() => {
        this.$refs.uploadd.setRefFileList();
      });
    },
    handleEdit(row, filterArr = ['updated_at', 'deleted_at', 'created_at', 'login_time']) {
      this.type = 'edit';
      this.title = '编辑';
      this.ruleForm = this.$until.delProp(row, filterArr);
      this.tableData1 = [];
      this.tableId = row.id;
      this.getItemList();
      this.users = [{ id: row.check_fzr_id, name: row.check_fzr }];
      this.handleCheckChange(row.check_form_id);
      this.centerDialogVisible = true;
    },
    handleEditItem(row, filterArr = ['school_id']) {
      this.typee = 'edit';
      this.itemTitle = '编辑检查项目';
      this.ruleForm1 = this.$until.delProp(row, filterArr);
      this.selectVal = row.name;
      this.maxScore = this.$until.getLabelName(this.checkTableItem, 'content', 'score', row.name);
      this.fileList = row.file ? row.file.split(',') : [];
      this.$nextTick(() => {
        if (row.file) {
          this.$refs.uploadd.setRefFileList(row.file);
        }
      });

      this.innerDialogVisible = true;
    },
    async getItemList() {
      let res = await this.$api.instance.interfaceServer(`api/safety_check/record/detail/${this.tableId}`, 'get', {});
      if (res.code == 0 && res.data) {
        // console.log( this.treeArr)
        this.tableData1 = res.data.items;
      }
    },
    handleNode() {
      console.log(this.currentNode);
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/safety_check/record/delete/${params.id}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/safety_check/record/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer(`api/safety_check/record/edit/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    async addCheckItem() {
      let params = this.$until.easyDeepCopy(this.ruleForm);1;
      params.file = this.fileList.length > 0 ? this.fileList.join(',') : '';
      let res = await this.$api.instance.interfaceServer(`api/safety_check/record/item/add/${this.tableId}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '添加项目成功！',
        });
        this.clearState1();
      }
    },
    async updateCheckItem() {
      let params = this.$until.easyDeepCopy(this.ruleForm);1;
      let res = await this.$api.instance.interfaceServer(`api/safety_check/record/item/edit/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑项目成功！',
        });
        this.clearState1();
      }
    },
    clearState1() {
      this.resetForm('ruleForm1');
      this.ruleForm1 = {
        name: '',
        score: '',
        desc: '',
        file: '',
        rectify_status: '',
        level: '',
        rectify_limit_date: '',
      };
      this.fileList = [];
      this.innerDialogVisible = false;
      this.getItemList();
    },
    getOrganList() {
      this.tableData1 = [];
      console.log(this.ruleForm);
      if (this.selectNode.level == 3) {
        this.selectName = this.selectNode.structure_names || this.selectNode.name;
        let strArr = this.selectNode.structure_names.split('-');
        this.ruleForm.structure_1 = strArr[0];
        this.ruleForm.major = strArr[1];
        this.ruleForm.class = strArr[2];
      }
      if (!this.selectName) {
        this.ruleForm.structure_1 = '';
        this.ruleForm.major = '';
        this.ruleForm.class = '';
      }

      // this.ruleForm.type_value = this.selectNode.structure_ids;
      // this.organs = [this.selectNode];
    },
    handleQuery() {
      this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/safety_check/record/list', 'get', params);
      if (res.code == 0 && res.data) {
        // console.log( this.treeArr)
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-link {
  margin-right: 4px;
}
.pageHeader:before {
  width: var(--width);
}
</style>
